import { useEffect, useState } from "react";
import { getGames, deleteGame } from "../../services/api";
import { Button } from "../../components/ui/button";
import { useNavigate } from "react-router-dom";
import axios from "axios";

export default function GameList() {
  const [games, setGames] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    getGames().then((res) => setGames(res.data));
  }, []);

  const handleDelete = async (id) => {
    if (confirm("Tem certeza?")) {
      await deleteGame(id);
      setGames(games.filter((g) => g._id !== id));
    }
  };

  return (
    <div className="p-6 mt-20">
      <h1 className="text-2xl font-bold mb-4">Partidas</h1>
      <Button onClick={() => navigate("/admin/games/new")}>
        + Nova Partida
      </Button>

      <div className="mt-4 grid gap-4">
        {games.map((game) => (
          <div key={game._id} className="p-4 rounded-xl shadow bg-white">
            <div className="flex justify-between">
              <div>
                <p>
                  <strong>Data:</strong> {game.date}
                </p>
                <p>
                  <strong>Campeonato:</strong> {game.league} - {game.season}
                </p>
                <p>
                  <strong>Times:</strong>{" "}
                  {game.teams?.home?._id?.name ?? "Sem time"} x{" "}
                  {game.teams?.away?._id?.name ?? "Sem time"}
                </p>
              </div>
              <div className="space-x-2">
                <Button
                  onClick={() => navigate(`/admin/games/scout/${game._id}`)}
                >
                  Abrir
                </Button>
                <Button
                  onClick={() => navigate(`/admin/games/edit/${game._id}`)}
                >
                  Editar
                </Button>
                <Button
                  variant="destructive"
                  onClick={() => handleDelete(game._id)}
                >
                  Excluir
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function PublicGameList() {
  const [games, setGames] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/games`)
      .then((res) => setGames(res.data));
  }, []);

  return (
    <div className="p-6 mt-20">
      <h1 className="text-2xl font-bold mb-4">Jogos</h1>
      <div className="mt-4 grid gap-4">
        {games.map((game) => (
          <div key={game._id} className="p-4 rounded-xl shadow bg-white">
            <div className="flex justify-between">
              <div>
                <p>
                  <strong>Data:</strong> {game.date}
                </p>
                <p>
                  <strong>Campeonato:</strong> {game.league} - {game.season}
                </p>
                <p>
                  <strong>Times:</strong> {game.teams?.home?.name ?? "Sem time"}{" "}
                  x {game.teams?.away?.name ?? "Sem time"}
                </p>
              </div>
              <div>
                <button
                  className="btn btn-primary"
                  onClick={() => navigate(`/games/${game._id}`)}
                >
                  Ver Scout
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
